r<template>
  <div class="wrapper">
    <a href="#main-content"
      class="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-gold-brush text-white p-4 z-[2000]">
      Aller au contenu principal
    </a>
    <Header></Header>
    <main id="main-content" role="main">
      <RouterView></RouterView>
    </main>
    <Footer></Footer>
  </div>
</template>
<script setup lang='ts'>
//Import packages
import { RouterView, useRoute } from 'vue-router';
import { useHead } from '@unhead/vue';
import { computed } from 'vue';
import Header from '@/components/organisms/header/Header.vue';
import Footer from '@/components/organisms/footer/Footer.vue';
import { onMounted } from 'vue';
//Import components

//Import assets

//Import stores
const route = useRoute();

// Configuration SEO globale et dynamique par défaut
useHead(computed(() => ({
  htmlAttrs: {
    lang: 'fr'
  },
  meta: [
    { property: 'og:type', content: 'website' },
    { property: 'og:image', content: 'https://dorotheearmbruster.com/assets/img/home-about-me.webp' },
    { property: 'og:url', content: `https://dorotheearmbruster.com${route.path}` },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:image', content: 'https://dorotheearmbruster.com/assets/img/home-about-me.webp' }
  ],
  link: [
    { rel: 'canonical', href: `https://dorotheearmbruster.com${route.path}` }
  ]
})));

onMounted(() => {
  // Init other scripts here if needed
});
</script>
<style scoped lang='scss'>
.wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}

#main-content {
  min-height: 100vh;
}</style>